export const name = "POWER";
export const summary = `Synonym of \`POW\`.`;
export const reference = `
## POWER

Synonym of \`POW\`.

\`\`\`
POWER(X, Y)
\`\`\`

### Description

Synonym of \`POW(X, Y)\`.


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
